import { css } from '@emotion/react';
import { Primary, p2r } from '../../styles/fonts';
import { colors, breakpoints } from '../../styles';

const { blackLight } = colors;

const styles = ({ sign = '' }) => css`
  .HeadAdv-logo {
    padding-top: ${p2r(20)};
  }

  .HeadAdv-logo > div {
    background: none;
  }

  .HeadAdv-logo > div > div {
    justify-content: flex-end;
  }

  .HeadAdv-logo > div > div > div > span,
  .HeadAdv-logo > div > div > h3 {
    display: none;
  }

  .HeadAdv-logo > div > div > div::before {
    position: relative;
    top: ${p2r(8)};
    display: inline-block;
    margin: 0 ${p2r(16)} 0 0;
    font: normal normal 500 ${p2r(14)} / ${p2r(17)} ${Primary};
    font-size: ${p2r(14)};
    color: ${blackLight};
    text-transform: initial;
    content: '${sign}';
  }

  .HeadAdv-logo > div > div > div > div > a > img {
    max-width: 128px;
    min-height: ${p2r(64)};
  }

  @media (max-width: ${breakpoints.smallTablet}px) {
    .HeadAdv-logo > div > div > div::before {
      top: ${p2r(40)};
      left: -80%;
    }
  }

  @media (max-width: ${breakpoints.hugeMobile}px) {
    .HeadAdv-logo {
      padding: ${p2r(30)} 0 ${p2r(32)};
    }

    .HeadAdv-logo > div > div > div::before {
      font-size: ${p2r(14)};
    }
  }

  @media (max-width: ${breakpoints.mobile}px) {
    .HeadAdv-logo > div > div > div::before {
      font-size: ${p2r(12)};
    }

    .home-page-HeadAdv-block > div {
      padding: 0;
    }
  }
`;

export default styles;
